<template>
  <form @submit.prevent="save"
        :class="`event${eventId}`"
        class="edit-description textarea-wrap">
    <label class="input-cont_small">
      <p class="label">
        {{$t('index.journal.edit.eventHeader')}}
      </p>
      <input v-model="head">
    </label>
    <vue-editor v-model="customText"
                class="editor my-editor"
                useCustomImageHandler
                @focus="getImageId()"
                :editorOptions="editorSettings"
                @image-added="uploadEditorImage"
                @image-removed="removeEditorImage"
                @text-change="textChange"></vue-editor>
    <div class="btns-cont">
      <button type="button"
              @click="cancel"
              class="btn btn-transparent_blue">{{$t('btns.cancel')}}</button>
      <button type="submit"
              class="btn btn-blue">{{$t('btns.send')}}</button>
    </div>
  </form>
</template>

<script>
import {editorConfig} from "@/mixins/editorConfig";
import {mapActions} from "vuex";
import {toFormData} from "../../../mixins/utils/toFormData";

export default {
    name: 'editDescription',
    props: {
      eventId: [Number, String],
      title: String,
      content: Object
    },
    mixins: [
      toFormData,
      editorConfig
    ],
    data() {
      return {
        textAlignButtons: null
      }
    },
    methods: {
      ...mapActions({
        uploadFile: 'global/uploadFile',
        removeFile: 'global/removeFile',
      }),

      async uploadEditorImage(file, Editor, cursorLocation) {
        let data = {
          files: file
        }
        let formData = this.toFormData(data)
        await this.uploadFile(formData).then(data => {
          this.imageUrl = data[0].filepath;
          this.imageId = data[0].id;
          this.imagesArr.push({
            id: data[0].id,
            url: data[0].filepath
          });
          Editor.insertEmbed(cursorLocation, "image", data[0].filepath);
        })
      },
      removeEditorImage(image) {
        let id = 0;
        this.imagesArr.forEach((item) => {
          if (item.url === String(image)) {
            id = item.id
          }
        })
        if (this.removeFilesIds === '') {
          this.removeFilesIds = id;
        } else {
          this.removeFilesIds += ', ' + id;
        }
      },
      textChange(delta, oldDelta, source) {
        if (!this.undoRedoFlag) {
          if (this.customText.indexOf(this.imageUrl) !== -1 && this.imageUrl !== null) {
            document.querySelector('.ql-editor').innerHTML = this.customText.replace(this.imageUrl, this.imageUrl + '" id="' + this.imageId + '"')
            this.customText = this.customText.replace(this.imageUrl, this.imageUrl + '" id="' + this.imageId + '"')
            this.imageUrl = null
          }

          this.history.splice(this.position, 1000000)
          this.history.push(this.customText)
          this.position++
        }
        this.undoRedoFlag = false
      },
      getImageId() {
        this.imagesArr = [];
        let imageBlock = document.querySelector(`.event${this.eventId}`);
        let images = imageBlock.querySelectorAll('img');
        images.forEach((image) => {
          this.imagesArr.push({
            id: image.getAttribute('id'),
            url: image.getAttribute('src')
          })
        })
      },
      cancel() {
        this.$emit('cancel')
      },
      async save() {
        if (this.removeFilesIds !== '') {
          let removeFileData = {
            ids: this.removeFilesIds
          }
          await this.removeFile(removeFileData);
        }
        let obj = this.content;
        obj.textContent = this.customText;
        obj.eventTitle = this.head;
        this.$emit('save', obj);
        this.cancel()
      },
    },
    mounted() {
      this.head = this.title;
      this.customText = this.content.textContent;
      this.setLabels();

      this.textAlignButtons = document.querySelectorAll('.ql-align')
      this.textAlignButtons.forEach(btn => {
        btn.onclick = function () {
          let divArr = document.querySelector('#quill-container').childNodes
          divArr[3].style.left = '-2000px'
        }
      })
    },
    beforeDestroy() {
      this.textAlignButtons.forEach(btn => {
        btn.onclick = function () {
          btn.removeAttribute("onclick")
        }
      })
      this.textAlignButtons = null
    }
}
</script>

<style lang="scss" scoped>

  .btns-cont {
    display: flex;
    margin-top: 40px;
    margin-left: -10px;
    margin-right: -10px;
    justify-content: flex-end;

    .btn{
      margin: 0 10px;
      max-width: 170px;
    }
  }

  .input-cont_small {
    width: 100%;

    input {
      width: 100%;
    }
  }

  .editor {
    margin-top: 10px;


  }
</style>
